// extracted by mini-css-extract-plugin
export default {"snackbar":"Snackbar_snackbar__StvjI","snackbarError":"Snackbar_snackbarError__ejp12","snackbarSuccess":"Snackbar_snackbarSuccess__E6agi"};